export const volleyballRules = [
  {
    title: 'Court Dimensions',
    type: 'info',
    diagram: {
      label: 'Court Size',
      value: '59\' × 29.5\''
    },
    points: [
      'Court: 18 meters (59 feet) long × 9 meters (29.5 feet) wide',
      'Net height (men): 7 feet 11⅝ inches',
      'Net height (women): 7 feet 4⅛ inches',
      'Attack line: 3 meters (10 feet) from net'
    ],
    keyFact: 'Beach volleyball courts are slightly smaller at 16m × 8m!'
  },
  {
    title: 'Team Composition',
    type: 'info',
    diagram: {
      label: 'Players per Team',
      value: '6'
    },
    points: [
      '6 players per team on court (indoor)',
      '2 players per team (beach volleyball)',
      'Players rotate positions clockwise after winning serve',
      'Unlimited substitutions (with restrictions)'
    ],
    keyFact: 'Liberos wear different colored jerseys and have special defensive roles!'
  },
  {
    title: 'Scoring System',
    type: 'info',
    diagram: {
      label: 'Points to Win',
      value: '25'
    },
    points: [
      'Rally scoring: point on every serve',
      'Sets won at 25 points (must win by 2)',
      'Fifth set (if needed) played to 15 points',
      'Best of 5 sets wins the match'
    ],
    keyFact: 'Before 1999, only the serving team could score points!'
  },
  {
    title: 'Touch Rules',
    type: 'info',
    diagram: {
      label: 'Maximum Touches',
      value: '3'
    },
    points: [
      'Maximum 3 touches per side before return',
      'Block touch does not count as first touch',
      'Same player cannot touch ball twice consecutively (except blocks)',
      'Ball can touch any part of the body'
    ],
    keyFact: 'The ball can legally touch any part of your body, even your foot!'
  },
  {
    title: 'Net Violations',
    type: 'dont',
    points: [
      'Cannot touch the net while ball is in play',
      'Cannot reach over net to attack (except on follow-through)',
      'Cannot cross centerline with entire foot',
      'Back row players cannot attack from in front of attack line'
    ],
    keyFact: 'Touching the net with hair or loose clothing is allowed if it does not affect play!'
  },
  {
    title: 'Service Rules',
    type: 'do',
    points: [
      'Server must hit ball within 8 seconds of referee whistle',
      'Serve must go over net without touching it',
      'Can serve from anywhere behind end line',
      'Ball touching net on serve (let) is legal and play continues'
    ],
    keyFact: 'Jump serves can reach speeds over 80 mph in professional play!'
  }
];

export const volleyballGoverningBodies = [
  {
    name: 'FIVB',
    description: 'Fédération Internationale de Volleyball - International governing body with 222 affiliated federations. Organizes World Championships and sets global rules.',
    website: 'https://www.fivb.com'
  },
  {
    name: 'USA Volleyball',
    description: 'National governing body for volleyball in the United States, overseeing national teams, youth development, and all volleyball disciplines.',
    website: 'https://usavolleyball.org'
  }
];

export const volleyballTournaments = [
  {
    name: 'FIVB Volleyball World Championship',
    description: 'Premier international tournament held every 4 years for both men and women, featuring the top national teams worldwide.',
    website: 'https://www.fivb.com/en/volleyball/competitions'
  },
  {
    name: 'Olympic Volleyball',
    description: 'Both indoor and beach volleyball competitions at the Summer Olympics featuring 12 teams in each discipline.',
    website: 'https://www.fivb.com/en/volleyball/olympics'
  },
  {
    name: 'NCAA Volleyball Championship',
    description: 'Annual collegiate championship featuring 64 teams competing in single-elimination tournament.',
    website: 'https://www.ncaa.com/sports/volleyball-women/d1'
  },
  {
    name: 'AVP Pro Beach Volleyball Tour',
    description: 'Premier professional beach volleyball tour in the United States with events across the country.',
    website: 'https://www.avp.com'
  }
];

export const volleyballResources = [
  {
    name: 'USA Volleyball Events',
    website: 'https://usavolleyball.org/events/'
  },
  {
    name: 'FIVB World Rankings',
    website: 'https://www.fivb.com/en/volleyball/rankings'
  },
  {
    name: 'NCAA Volleyball',
    website: 'https://www.ncaa.com/sports/volleyball-women'
  }
];
